var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loggedIn === false)?_c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-main',[_c('router-view')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }